import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './HomePageGoogle.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
// images
import LocationReviewsData from './LocationReviewsData'
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import emailjs from 'emailjs-com';

export default function HomePageGoogle({ locationsMain, CitiePhone, CitiesData }) {
    const location = useLocation()
    const navigate = useNavigate()
    const [response, setResponse] = useState({});
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const url = new URL(window.location.href);
    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    const data = {
        title: "",
        rows: [

            {
                title: "Why choose Smith & Sons Chimney?",
                content: "With 50 years of expertise, we provide professional, reliable chimney services, ensuring safety and efficiency in every home."
            },
            {
                title: "What services do you offer?",
                content: "We offer chimney cleaning, inspection, repairs, maintenance, creosote removal, waterproofing, and more for optimal performance."
            },
            {
                title: "How much is a chimney inspection?",
                content: "Our chimney inspection costs $69. It includes a comprehensive check to identify potential issues."
            },
            {
                title: "Can you clean and repair together?",
                content: "Yes, we offer same-day cleaning and repair services during your appointment if needed."
            },
            {
                title: `Do you provide services surrounding ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}?`,
                content: `Yes, we don't just serve ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}! We cover a wide area, including a 75-mile radius around ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}. Whether you're in nearby towns or surrounding areas, we're here to help.`
            },
            {
                title: "How do I book an appointment?",
                content: `Call us <a href='tel:${CitiePhone}'>${CitiePhone}</a> or fill out the <a href='/book${location.search}'>online form</a> to schedule your visit.`
            },

        ]
    };
    const styles = {
        bgColor: 'white',
        titleTextColor: 'white',
        titleTextSize: '18px',
        rowTitleColor: '#082d49',
        rowTitleTextSize: '21px',
        rowContentColor: '#082d49',
        rowContentTextSize: '16px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "#082d49",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "Smith & Sons chimney sweep" can help our clients with that kind of service, give me that as json file: title 3 words (include in the title words from the keyword, remove null and Smith & Sons chimmney sweep from title)(if no keywords just do for chimney sweep) and body`
                const apiKey = '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'; // Replace with your actual API key
                const resChat = await fetch(`https://api.openai.com/v1/chat/completions`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiKey}`,
                    },
                    body: JSON.stringify({
                        'model': 'gpt-3.5-turbo',
                        'messages': [
                            {
                                'role': 'user',
                                'content': searchKeyword
                            }
                        ]
                    })
                })
                const dataChat = await resChat.json()
                console.log(dataChat.choices[0].message.content)
                setResponse(JSON.parse(dataChat.choices[0].message.content))
            } catch (error) {
                console.log(error);
            }
        })();
    }, []);

    return (
        <div className="HomePageGoogle" id="homepage">
            <Helmet>
                {/* <!-- TITLE -->  */}
                {/* <!-- Maximum of 65 characters --> */}
                <title>Smith & Sons Chimney | Expert Chimney Cleaning, Inspection & Services | {CitiePhone}</title>
                {/* <!-- Maximum 35 characters --> */}
                <meta name="title" property="title" content="Chimney Sweep | Expert Chimney Cleaning, Inspection & Services | {CitiePhone}" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Chimney Sweep | Expert Chimney Cleaning, Inspection & Services | {CitiePhone}" data-react-helmet="true" />
                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="article" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="article" data-react-helmet="true" />
                {/* <!-- Full link to the current webpage address -->  */}
                <meta name="og:url" property="og:url" content="https://www.smithandsonschimney.com/" data-react-helmet="true" />
                {/* <!-- Maximum of 155 characters  --> */}
                <meta name="description" content="Chimney Sweep provides top-quality chimney cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your chimney service needs." data-react-helmet="true" />
                {/* <!-- Maximum 65 characters --> */}
                <meta name="og:description" property="og:description" content="Chimney Sweep provides top-quality chimney cleaning, inspections, and repairs to keep your home safe and efficient. Trust our experienced professionals for all your chimney service needs." data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content="Chimney Sweep" data-react-helmet="true" />
                <meta name="keywords" content="chimney sweep, chimney Inspection, Chimney Inspection, Fireplace Inspection, Fireplace Cleaning, Chimney Cleaning, Chimney Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Chimney Inspection, Fireplace Inspection, Fireplace Cleaning, Chimney Cleaning, Chimney Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, chimney services, chimney service, Chimney Inspection, Fireplace Inspection, Fireplace Cleaning, Chimney Cleaning, Chimney Maintenance, Fireplace Maintenance, Dryer Vent Cleaning, Chimney Insulation, Chimney Installation, Chimney Liner Repair, Chimney Pointing, Chimney Rainp Installation, Chimney Repair, Chimney Crown Repair, Chimney Restoration, Chimney Flue Installation, Chimney Flue Repair, ​Chimney Construction, Chimney Vent Installation, Chimney Flashing, Flexible Chimney Liner Installation, Chimney Damper Repair, Chimneyp Repair, Fireplace Insulation, Fireplace Installation, Fireplace Liner Repair, Fireplace Pointing, Fireplace Rainp Installation, Fireplace Repair, Fireplace Crown Repair, Fireplace Restoration, Fireplace Flue Installation, Fireplace Flue Repair, Ffireplace Construction, Fireplace Vent Installation, Fireplace Flashing, Flexible fireplace Liner Installation, Fireplace Damper Repair, Fireplacep" data-react-helmet="true" />
            </Helmet>
            {/* MainBanner */}
            <div className="MainBanner">
                <div className="MainBannerLeft">
                    <h1>PREMIUM CHIMNEY SERVICE IN {CitiesData && CitiesData.City ? CitiesData.Full.toUpperCase() : "YOUR AREA"} IS OUR SUPERPOWER</h1>
                    <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas • <span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', '•') : url.searchParams.get('kd') + "," : ""}</span> Chimney Inspections, Repair And Cleaning Near Me</h2>
                    <div className="MainBannerLeftButtons">
                        <a href={`tel:${CitiePhone}`}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                        <a onClick={() => navigate(`/book${location.search}`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me BHO" /></a>
                    </div>
                    <div className="MainBannerLeftRated">
                        <h3>Rated 4.9 on Google</h3>
                        <span>
                            <h4>4.9</h4>
                            <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                        </span>
                    </div>
                </div>
                <div className="MainBannerRight">
                    <img fetchpriority="low" src={require(`../../ImagesLogos/Banner6Logo.png`)} />
                </div>
            </div>
            {/* MainBanner2Top2 */}

            <div className="MainBanner2Top2" id="about">
                <div className="MainBanner2Top2Bottom">
                    <a>No extra charge for appointments on nights, weekends or holidays</a>
                </div>
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <div className="MainBanner2TopBoxBoxBox">
                            <img src={require(`../../Images/chimneycleaning.png`)} alt="Chimney Cleaning" />
                        </div>
                        <h3>CHIMNEY CLEANING</h3>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <div className="MainBanner2TopBoxBoxBox">
                            <img src={require(`../../Images/chimneyinspection.png`)} alt="Chimney Cleaning" />
                        </div>
                        <h3>CHIMNEY INSPECTION</h3>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <div className="MainBanner2TopBoxBoxBox">
                            <img src={require(`../../Images/chimneymaintenance.png`)} alt="Chimney Cleaning" />
                        </div>
                        <h3>CHIMNEY MAINTENANCE</h3>
                    </a>
                    <a className="MainBanner2TopBoxBox">
                        <div className="MainBanner2TopBoxBoxBox">
                            <img src={require(`../../Images/chimneyrepair.png`)} alt="Chimney Cleaning" />
                        </div>
                        <h3>CHIMNEY REPAIR</h3>
                    </a>
                </div>

                <div className="MainBanner2TopBoxMainChat">
                    <img src={require(`../../ImagesLogos/Banner3Logo.png`)} />
                    <div className="MainBanner2TopBoxMainChatText">
                        <h4>{response.title}</h4>
                        <h3>{response.body}</h3>
                        <h5>Call us at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> or fill out the <a href={`/book${location.search}`}>online form</a> to schedule your visit.</h5>
                    </div>
                </div>
            </div>
            {/* HomePageGoogleBen */}
            <div className="HomePageGoogleBen">
                <div className="HomePageGoogleBenLEFT">
                    <img fetchpriority="low" src={require(`../../ImagesLogos/Image2Logo.png`)} />
                </div>
                <div className="HomePageGoogleBenRIGHT">
                    <h1>SUPER BENEFITS</h1>
                    <div className="HomePageGoogleBenRIGHTList">
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>
                                Highly Trained & Certified Technicians
                                <h3>- Our Chimney technicians completed more than 6,500 hours of training in 2022</h3>
                                <h3>- Our Technicians complete 45+ hours yearly of weekly skills training</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>
                                Fast Response Time
                                <h3>- 24/7 emergency appointments available</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>
                                Satisfaction Guaranteed
                                <h3>- 6,000+ five-star reviews</h3>
                            </h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>Fully Licensed & Insured</h2>
                        </div>
                        <div className="HomePageGoogleBenRIGHTListBox">
                            <img fetchpriority="low" src={require(`../../Images/checklist.png`)} />
                            <h2>Friendly Customer Service</h2>
                        </div>
                    </div>
                </div>
            </div>
            {/* HomePageGoogleUs */}
            <div className="HomePageGoogleUs">
                <div className="HomePageGoogleUsLeft">
                    <h1>KEEPING YOUR CHIMNEY SAFE</h1>
                    <h2>
                        When you’ve got a chimney issue, there’s only one name to call — Smith & Sons Chimney. And it’s not just because of our decades of experience, our stellar reviews, or even our industry awards. It’s because everything we do; we do with your safety and comfort in mind.
                    </h2>
                    <div className="HomePageGoogleUsLeftMoreBox">
                        <h3>HERITAGE</h3>
                        <h4>Proudly serving communities since 2001, built on decades of trusted chimney expertise.</h4>
                    </div>
                    <div className="HomePageGoogleUsLeftMoreBox">
                        <h3>RESPONSIVENESS</h3>
                        <h4>Always ready when you need us—rapid service, including same-day and emergency visits, year-round.</h4>
                    </div>
                    <div className="HomePageGoogleUsLeftMoreBox">
                        <h3>EXCELLENCE</h3>
                        <h4>Comprehensive chimney services delivered with cutting-edge tools and meticulous attention to detail.</h4>
                    </div>
                    <h6>The team that keeps your family safe and warm with every call.</h6>
                    <div className="MainBannerLeftButtons">
                        <a href={`tel:${CitiePhone}`}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                        <a onClick={() => navigate(`/book${location.search}`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me Smith & Sons Chimney" /></a>
                    </div>
                </div>
                <div className="HomePageGoogRight">
                    <img fetchpriority="low" src={require(`../../Images/Chimney1.jpeg`)} />
                    <img fetchpriority="low" src={require(`../../Images/Chimney3.jpeg`)} />
                </div>
            </div>
            {/* MainBannerMore */}
            <div className="MainBannerMore">
                <diiv className="MainBannerMoreLeft">
                    <h1>Your Trusted Experts for All Your Chimney Needs!</h1>
                    <a href={`tel:${CitiePhone}`}>CALL NOW TO SCHEDULE</a>
                    <a href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                </diiv>
                <img fetchpriority="low" src={require(`../../ImagesLogos/Banner5Logo.png`)} />

            </div>
            {/* HomePageGoogleReviews */}
            <div className="HomePageGoogleReviews" id='reviews'>
                <h1>Real Testimonials from Our Valued Client in {CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}</h1>
                <div className="LocationReviewsLsit">
                    <div className="LocationReviewsLsitUnder">
                        {LocationReviewsData.slice(0, 36).map((A, index) =>
                            <div key={index} className="LocationReviewsBox">
                                <div className="LocationReviewsBoxLeft">
                                    {/* <h3>Open Now 24/7 • Top Rated • Same Day Service</h3> */}
                                    <span>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/star.png`)}></img>
                                        <img src={require(`../../Images/checklist.png`)}></img>
                                    </span>
                                    <h2><img src={require(`../../Images/GoogleIcons.png`)}></img>Rated 5 By {A.customer_name}</h2>
                                    <h4>{A.review}</h4>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="LocationReviewsLsitShodowR"></div>
                </div>
            </div>
            {/* HomePageGoogleCar */}
            <div className="HomePageGoogleCar">
                <div className="HomePageGoogleCarMain">
                    <div className="HomePageGoogleCarLeft">
                        <img fetchpriority="low" src={require(`../../ImagesLogos/Banner4Logo.png`)} />
                    </div>
                    <div className="HomePageGoogleCarRight">
                        <h1>CHIMNEY SWEEP & FIREPLACE EXPERT <br /> IN {CitiesData && CitiesData.City ? CitiesData.Full.toUpperCase() : "YOUR AREA"}</h1>
                        <h2>Call For Service:</h2>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                            <a onClick={() => navigate(`/book${location.search}`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me BHO" /></a>
                        </div>
                    </div>
                </div>
                <div className="HomePageGoogleCarBottom">
                    <a>No extra charge for appointments on nights, weekends or holidays</a>
                </div>
            </div>
            {/* BookAnAppointment */}
            <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
            {/* HomePageGoogleService */}
            <div className="HomePageGoogleService" id="ourservices">
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>CHIMNEY CLEANING</h2>
                            <h3>
                                Your Trusted Partner for Chimney Cleaning in {CitiesData && CitiesData.City ? CitiesData.City : "Your Area"}
                                <br />
                                <br />
                                A clean chimney not only improves the performance of your fireplace but also keeps your home safe from potential fire hazards. Over time, soot and creosote buildup can restrict airflow and become dangerous. At Smith & Sons Chimney, our skilled team uses advanced techniques to thoroughly clean your chimney, leaving it safe and efficient for everyday use.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/ChimneyIM5.jpg`)} alt="Chimney Cleaning BHO" />
                        </div>
                    </div>
                    <div className="MainBanner2BottomBox">

                        <div className="MainBanner2BottomBoxLeft">
                            <h2>CHIMNEY INSPECTION</h2>
                            <h3>
                                Thorough Chimney Inspections for Peace of Mind
                                <br />
                                <br />
                                Routine chimney inspections are key to identifying and resolving hidden issues before they become major problems. Smith & Sons Chimney offers detailed inspections to uncover potential hazards like creosote buildup, blockages, or structural damage. With our expert assessments, your chimney stays in optimal condition, ensuring the safety of your household.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/ChimneyIM1.jpg`)} alt="Chimney Maintenance BHO" />
                        </div>
                    </div>
                </div>
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>CHIMNEY REPAIR</h2>
                            <h3>
                                Reliable Chimney Repair Solutions
                                <br />
                                <br />
                                Over time, chimneys can face a variety of issues, from weather damage to wear and tear. At Smith & Sons Chimney, we specialize in repairing cracks, leaks, and other structural problems to restore your chimney’s integrity. Our professional repair services ensure your fireplace functions efficiently and safely, no matter the season.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/ChimneyIM9.jpg`)} alt="Chimney Inspection BHO" />

                        </div>
                    </div>
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>GAS FIRREPLACE SERVICE</h2>
                            <h3>
                                Comprehensive Gas Fireplace Care
                                <br />
                                <br />
                                Smith & Sons Chimney provides expert gas fireplace services, including installation, repairs, and maintenance. Whether you need help with troubleshooting a malfunctioning pilot light or installing a new fireplace, our technicians deliver reliable and efficient solutions. Trust us to keep your fireplace operating smoothly year-round.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/Chimney9.png`)} alt="Chimney Repair BHO" />

                        </div>
                    </div>

                </div>
                <div className="MainBanner2Bottom">
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>CHIMNEY MASONRY</h2>
                            <h3>
                                Expert Chimney Masonry Services
                                <br />
                                <br />
                                The elements can take a toll on your chimney, causing cracks and structural issues. At Smith & Sons Chimney, we offer a full range of masonry services, including rebuilding, waterproofing, and crown repairs. Our experienced masons work meticulously to restore the beauty and durability of your chimney, ensuring it stands the test of time.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/ChimneyIM6.jpg`)} alt="Chimney Cleaning BHO" />

                        </div>
                    </div>
                    <div className="MainBanner2BottomBox">
                        <div className="MainBanner2BottomBoxLeft">
                            <h2>CHIMNEY MAINTENANCE</h2>
                            <h3>
                                Comprehensive Chimney Maintenance Plans
                                <br />
                                <br />
                                Ensure the longevity and performance of your chimney with our proactive maintenance services. At Smith & Sons Chimney, we provide tailored maintenance plans to keep your chimney clean, safe, and efficient. From routine inspections to preventative care, we help you enjoy worry-free fireplace usage all year long.
                                <br />
                                <br />
                            </h3>
                        </div>
                        <div className="MainBanner2BottomBoxRight">
                            <img src={require(`../../Images/ChimneyIM8.jpg`)} alt="Chimney Repair BHO" />

                        </div>


                    </div>
                </div>
            </div>
            {/* locationsMain */}
            {locationsMain.find(a => a.Phone == CitiePhone) ?
                <div className="HomePageGoogleLocation">
                    <div className="HomePageGoogleLocationLeft">
                        <h1>WHERE YOU'LL FIND SMITH & SONS CHIMNEY</h1>
                        <h2>Smith & Sons Chimney proudly serves families, offering expert chimney services. Our skilled technicians are just a short phone call away, ready to assist in neighborhoods throughout <b>{CitiesData && CitiesData.City ? CitiesData.Full.toUpperCase() : "Your Area"}</b>, and the surrounding areas.</h2>
                        {locationsMain.find(a => a.Phone == CitiePhone).Address.map((A, index) =>
                            <div key={index} className="HomePageGoogleLocationLeftBox">
                                <h4>{A.Location1}</h4>
                                <h5>{A.Address1}</h5>
                                <a href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                            </div>
                        )}
                    </div>
                    <div className="HomePageGoogleLocationRight">
                        <div className="HomePageGoogleLocationRightMap">

                            <div className="HomePageGoogleLocationRightBorder"></div>
                            <iframe src={locationsMain.find(a => a.Phone == CitiePhone).Map} ></iframe>
                        </div>
                        <div className="HomePageGoogleLocationRightBox">
                            <h4>Smith & Sons Chimney is proud to provide expert chimney cleaning, inspection, and repair services to the {CitiesData && CitiesData.City ? CitiesData.City : "Your Area"} area.</h4>
                            <div className="HomePageGoogleLocationRightBoxMenu">
                                <span>
                                    <h2>Manager:</h2>
                                    <h3>Mike Oliver</h3>
                                </span>
                                <span>
                                    <h2>Phone Number:</h2>
                                    <h3>{CitiePhone ? CitiePhone : "866-907-7220"}</h3>
                                </span>
                            </div>

                        </div>
                    </div>
                </div>
                : null}
            {/* HomePageGoogleFAQ */}
            <div className="HomePageGoogleFAQ">
                <h2>GOT QUESTIONS? WE'VE GOT ANSWERS.</h2>
                <h3>Feel Free To Reach Out To Us By Phone. For The Fastest Response, We Are Available By Phone 24/7 And Ready To Provide You With A Complimentary Consultation.</h3>
                <div className="MainBannerLeftButtons">
                    <a href={`tel:${CitiePhone}`}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                    <a onClick={() => navigate(`/book${location.search}`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me BHO" /></a>
                </div>
                <div className="MainBanner4FaqMore">
                    <Faq
                        data={data}
                        styles={styles}
                        config={config}
                    />
                </div>
            </div>
            {/* HomePageGoogleFooter */}
            <div className="HomePageGoogleFooter" id='footer'>
                <div className="HomePageGoogleFooterTop">
                    <div className="HomePageGoogleFooterTopTitle">
                        <h1>RELIABLE SERVICE, TRUSTED RESULTS</h1>
                        <h2>BOOK YOUR APPOINTMENT NOW!</h2>
                        <h3>With our highly-skilled technicians & upfront pricing, you can trust the local {CitiesData && CitiesData.City ? CitiesData.Full : "Your Area"} experts at Smith & Sons Chimney for 100% satisfaction, guaranteed on all chimney sweep services.</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                            <a onClick={() => navigate(`/book${location.search}`)}>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me BHO" /></a>
                        </div>
                    </div>
                    <div className="HomePageGoogleFooterTopImg">
                        <img src={require(`../../ImagesLogos/Banner1Logo.png`)} />
                    </div>
                </div>
                <div className="HomePageGoogleFooterBottom">
                    <div className="HomePageGoogleFooterBottomTop">
                        <img src={require(`../../ImagesLogos/Banner2Logo.png`)} />
                        <p>Copyright © 2024 - Smith & Sons Chimney. All Rights Reserved. Privacy Policy</p>
                        <div className="SiteMapDiv">
                            <h1>Privacy</h1>
                            <a href="/privacy-policy">Privacy Policy</a>
                            <a href="/terms-and-conditions">Terms And Conditions</a>
                        </div>
                    </div>
                    {locationsMain.find(a => a.Phone == CitiePhone) ?
                        <div className="HomePageGoogleFooterMiddle">
                            <h1>OFFICE LOCATIONS</h1>
                            {locationsMain.find(a => a.Phone == CitiePhone).Address.map((A, index) =>
                                <div key={index} className="HomePageGoogleLocationLeftBox">
                                    <h4>{A.Location1}</h4>
                                    <h5>{A.Address1}</h5>
                                    <a href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                                </div>
                            )}
                        </div>
                        : null}
                    <div className="HomePageGoogleFooterBottomTop">
                        <h1>CONNECT WITH US</h1>
                        <p>Phone: {CitiePhone}</p>
                        <p>info@smithandsonschimney.com</p>
                        <p>www.smithandsonschimney.com</p>
                    </div>



                </div>
            </div>
        </div>
    )
}

